import { render } from "./FeedbackQuestionTree.vue?vue&type=template&id=da028b48"
import script from "./FeedbackQuestionTree.vue?vue&type=script&lang=js"
export * from "./FeedbackQuestionTree.vue?vue&type=script&lang=js"
script.render = render

export default script